<template>
  <div class="bxp-form">
    <span class="bxp-desktop-header">
      <div class="get-in-touch">
        <img
          class="env-img"
          src="https://mark-cdn.bountixp.com/marketing-v2/wp-content/uploads/2022/06/envelope.png"
        />
        <div class="get-in-touch-heading">
          <strong> Get in <font color="#A6CE38">touch</font> </strong>
        </div>
      </div>
      <div class="schedule-a-conversatation">
        Schedule a conversation with us so we can understand your needs and
        discuss how bountiXP can help <font color="#A6CE38">you</font>.
      </div>
      <div class="divider-line"></div>
    </span>
    <span class="bxp-mobile-header">
      <h1>
        <strong>Need some help? It’s closer than you think.</strong>
      </h1>
      <p class="heading-sub-text">
        If we haven't covered your questions in the
        <a href="/bountixp-faqs">FAQs</a>, send us your details and a message of
        enquiry and we'll get back to you with an answer, pronto!
      </p>
    </span>
    <div class="contact-us-gridlayout">
      <v-text-field
        id="first_name"
        label="First name"
        placeholder="Enter your first name"
        prepend-inner-icon="fas fa-user"
        color="secondary"
        @change="updateFirstName($event)"
        :append-outer-icon="fields.firstName.validationIcon"
        :success="fields.firstName.valid"
        :error="fields.firstName.valid === false"
        :hint="fields.firstName.validationMessage"
        :persistent-hint="true"
        v-scroll-to="{
          el: '#country',
          offset: -200,
        }"
      />

      <v-text-field
        label="Last name"
        placeholder="Enter your last name"
        prepend-inner-icon="fas fa-user"
        color="secondary"
        @change="updateLastName($event)"
        :append-outer-icon="fields.lastName.validationIcon"
        :success="fields.lastName.valid"
        :error="fields.lastName.valid === false"
        :hint="fields.lastName.validationMessage"
        :persistent-hint="true"
      />

      <v-autocomplete
        id="country"
        label="Country"
        placeholder="Add your location"
        v-model="countryValue"
        :items="fields.country.options"
        item-text="name"
        item-value="code"
        prepend-inner-icon="fas fa-map-marker-alt"
        color="secondary"
        @change="updateCountryValue($event)"
        :success="fields.country.valid"
        v-scroll-to="{
          el: '#country',
          offset: -40,
        }"
      >
        <!-- <template v-slot:append-outer>
          <v-tooltip
            left
            :open-on-hover="countryValue !== 'ZA'"
            max-width="320px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                v-on="countryValue !== 'ZA' ? on : null"
                :color="countryValue !== 'ZA' ? 'accent' : 'primary'"
                >{{ fields.country.validationIcon }}</v-icon
              >
            </template>
            <span>{{ fields.country.validationMessage }}</span>
          </v-tooltip>
        </template> -->
      </v-autocomplete>

      <v-text-field
        id="phone_number"
        label="Phone number"
        prepend-inner-icon="fas fa-phone"
        placeholder="Add your contact number"
        color="secondary"
        @change="updatePhoneNumber($event)"
        :append-outer-icon="fields.mobileNumber.validationIcon"
        :success="fields.mobileNumber.valid"
        :error="fields.mobileNumber.valid === false"
        :hint="fields.mobileNumber.validationMessage"
        :persistent-hint="true"
      />

      <v-text-field
        id="number_of_employees"
        label="Number of employees"
        prepend-inner-icon="fas fa-user"
        placeholder="Select number of employees"
        color="secondary"
        @change="updateEmployees($event)"
        :append-outer-icon="fields.employeeCount.validationIcon"
        :success="fields.employeeCount.valid"
        :error="fields.employeeCount.valid === false"
        :hint="fields.employeeCount.validationMessage"
        :persistent-hint="true"
      />

      <v-text-field
        class="bxp-small-icon"
        label="Work email address"
        color="secondary"
        placeholder="Add your work email address"
        prepend-inner-icon="fas fa-envelope"
        v-model="emailValue"
        :append-outer-icon="fields.email.validationIcon"
        :success="fields.email.valid"
        :error="fields.email.valid === false"
        :hint="fields.email.validationMessage"
        :persistent-hint="true"
        :loading="fields.email.loading"
        autocomplete="off"
      />

      <v-text-field
        id="company_name"
        label="Company name"
        prepend-inner-icon="fas fa-tag"
        placeholder="Add your company name"
        color="secondary"
        @change="updateCompanyName($event)"
        :append-outer-icon="fields.companyName.validationIcon"
        :success="fields.companyName.valid"
        :error="fields.companyName.valid === false"
        :hint="fields.companyName.validationMessage"
        :persistent-hint="true"
      />

      <v-text-field
        label="Leave us a message"
        placeholder="Add a message to your inquiry"
        @change="messageValue($event)"
        prepend-inner-icon="fas fa-envelope"
        color="secondary"
      />
    </div>

    <span class="agree-row">
      <v-checkbox
        class="bxp-checkbox"
        v-model="fields.termsAccepted"
        color="secondary"
      >
        <template v-slot:label
          >I agree to bountiXP's
          <a href="/terms-of-use/" target="_blank" @click.stop>terms of use</a>
          and
          <a href="/privacy-policy/" target="_blank" @click.stop
            >privacy policy</a
          >.
        </template>
      </v-checkbox>

      <div class="submit-button" id="contact-form-submit" @click="submitform">
        <tab-navigation />
      </div>

      <!-- <v-btn class="submit-button" outlined rounded color="#a6ce38">
        Submit
      </v-btn> -->
    </span>

    <span class="bxp-desktop-header">
      <div class="divider-line-office"></div>
      <div class="office-header">
        <img
          class="pin-img"
          src="https://mark-cdn.bountixp.com/marketing-v2/wp-content/uploads/2022/06/map-marker-alt.png"
        />
        <div class="office-header-text">
          <strong> Office <font color="#A6CE38">locations</font> </strong>
        </div>
      </div>
      <div class="office-locations">
        <div class="loc-1-header">South Africa</div>
        <div class="loc-1-address">
          14 Stibitz St, Westlake, Cape Town, South Africa, 7945
          <br />
          <span class="loc-1-email"
            ><a href="mailto:contact@boutixp.com">
              contact@boutixp.com
            </a></span
          >
          |
          <span class="address-maps-link"
            ><a href="https://goo.gl/maps/VNjyu79THsei2uFT9" target="_blank">
              View on Google Maps
            </a></span
          >
        </div>
        <div class="loc-2-header">United Kingdom</div>
        <div class="loc-1-address">
          36-38 Westbourne Grove, Newton Road, London W2 5SH, United Kingdom
          <br />
          <span class="loc-1-email"
            ><a href="mailto:contact@boutixp.com">
              contact@boutixp.com
            </a></span
          >
          |
          <span class="address-maps-link"
            ><a href="https://goo.gl/maps/pgZ2xh4a6xXw9Cut6" target="_blank">
              View on Google Maps
            </a></span
          >
        </div>
      </div>
    </span>
  </div>
</template>

<script>
import { VueMaskDirective } from "v-mask";
import { formBus } from "@/formBus";
import TabNavigation from "../../../../custom_modules/vue-multistep-form-wizard/src/components/TabNavigation.vue";

export default {
  components: { TabNavigation },
  directives: {
    mask: VueMaskDirective,
  },
  data() {
    return {
      error: false,
      loadingScreen: {
        show: false,
        success: false,
      },
    };
  },
  mounted() {
    if (window.location.search !== "") {
      var currentURL = window.location.href;
      var urlSplit = currentURL.split("&");
      var country = urlSplit[5].split("=")[1].toUpperCase();
      this.countryValue = country;
      let message = null;
      if (country === "") {
        this.updateValidation("country", false, message);
      } else {
        this.updateValidation("country", true, message);
      }
    }
  },
  computed: {
    fields() {
      return formBus.fields;
    },
    stepValid() {
      return (
        this.fields.firstName.valid &&
        this.fields.lastName.valid &&
        this.fields.country.valid &&
        this.fields.mobileNumber.valid &&
        this.fields.employeeCount.valid &&
        this.fields.email.valid &&
        this.fields.companyName.valid &&
        this.fields.termsAccepted
      );
    },
    emailValue: {
      get() {
        return this.fields.email.value;
      },
      set(val) {
        formBus.fields.email.loading = true;
        val = val.trim();
        formBus.fields.email.value = val;
        this.resetValidation("email", val);
        if (formBus.fields.email.timer !== null) {
          clearTimeout(formBus.fields.email.timer);
        }
        formBus.fields.email.timer = setTimeout(
          async (val) => {
            const emailValidation = await this.validateEmail(val);
            this.updateValidation(
              "email",
              emailValidation.valid,
              emailValidation.message
            );
            formBus.fields.email.loading = false;
          },
          2500,
          val
        );
      },
    },
    countryValue: {
      get() {
        return this.fields.country.value;
      },
      set(val) {
        formBus.fields.country.value = val;
        this.validateCountry(val);
      },
    },
    mobileNumberValue: {
      get() {
        return this.fields.mobileNumber.value;
      },
      set(val) {
        formBus.fields.mobileNumber.value = val;
      },
    },
  },
  methods: {
    updateFirstName(val) {
      this.fields.firstName.value = val;
      let valid = null;
      let message = null;
      if (val === "") {
        valid = false;
        message = "This field is incomplete";
      } else {
        valid = true;
        message = null;
      }
      this.updateValidation("firstName", valid, message);
    },
    updateLastName(val) {
      this.fields.lastName.value = val;
      let valid = null;
      let message = null;
      if (val === "") {
        valid = false;
        message = "This field is incomplete";
      } else {
        valid = true;
        message = null;
      }
      this.updateValidation("lastName", valid, message);
    },
    updateCompanyName(val) {
      this.fields.companyName.value = val;
      let valid = null;
      let message = null;
      if (val === "") {
        valid = false;
        message = "This field is incomplete";
      } else {
        valid = true;
        message = null;
      }
      this.updateValidation("companyName", valid, message);
    },
    updatePhoneNumber(val) {
      this.fields.mobileNumber.value = val;
      let valid = null;
      let message = null;
      if (val === "") {
        valid = false;
        message = "This field is incomplete";
      } else {
        valid = true;
        message = null;
      }
      this.updateValidation("mobileNumber", valid, message);
    },
    updateEmployees(val) {
      this.fields.employeeCount.value = val;
      let valid = null;
      let message = null;
      if (val === "") {
        valid = false;
        message = "This field is incomplete";
      } else {
        valid = true;
        message = null;
      }
      this.updateValidation("employeeCount", valid, message);
    },
    updateCountryValue(val) {
      this.fields.country.value = val;
      let valid = null;
      let message = null;
      if (val === "") {
        valid = false;
        message = "This field is incomplete";
      } else {
        valid = true;
        message = null;
      }
      this.updateValidation("country", true, message);
    },
    messageValue(val) {
      this.fields.message.value = val;
      let valid = null;
      let message = null;
      if (val === "") {
        valid = false;
        message = "This field is incomplete";
      } else {
        valid = true;
        message = null;
      }
      this.updateValidation("message", true, message);
    },
    async validateEmail(email) {
      //Empty field
      if (email === "") {
        return {
          valid: false,
          message: "This field is incomplete",
        };
      }
      //Email format
      const validCriteria =
        /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!validCriteria.test(email)) {
        return {
          valid: false,
          message: "Please enter a valid email address",
        };
      }
      //Uses a domain that's not blacklisted as non-work emails
      if (!this.isWorkEmail(email)) {
        return {
          valid: false,
          message: "Please enter your work email address",
        };
      }
      return {
        valid: true,
        message: null,
      };
    },
    submitform() {
      let cta;
      let ctaRefferer;
      let plan;
      let term;
      let country;
      if (window.location.search !== "") {
        var currentURL = window.location.href;
        var urlSplit = currentURL.split("&");

        cta = urlSplit[1].split("=")[1];
        ctaRefferer = urlSplit[2].split("=")[1];
        plan = urlSplit[3].split("=")[1];
        term = urlSplit[4].split("=")[1];
        country = urlSplit[5].split("=")[1];
      }

      if (!cta && !ctaRefferer && !plan && !term && !country) {
        cta = "NA";
        ctaRefferer = "NA";
        plan = "NA";
        term = "NA";
        country = "NA";
      }

      window._show_thank_you = function (id, message, trackcmp_url, email) {
        var form = document.getElementById("_form_" + id + "_"),
          thank_you = form.querySelector("._form-thank-you");
        form.querySelector("._form-content").style.display = "none";
        thank_you.innerHTML = message;
        thank_you.style.display = "block";
        const vgoAlias =
          typeof visitorGlobalObjectAlias === "undefined"
            ? "vgo"
            : visitorGlobalObjectAlias;
        var visitorObject = window[vgoAlias];
        if (email && typeof visitorObject !== "undefined") {
          visitorObject("setEmail", email);
          visitorObject("update");
        } else if (typeof trackcmp_url != "undefined" && trackcmp_url) {
          // Site tracking URL to use after inline form submission.
          _load_script(trackcmp_url);
        }
        if (typeof window._form_callback !== "undefined")
          window._form_callback(id);
      };
      window._show_error = function (id, message, html) {
        var form = document.getElementById("_form_" + id + "_"),
          err = document.createElement("div"),
          button = form.querySelector("button"),
          old_error = form.querySelector("._form_error");
        if (old_error) old_error.parentNode.removeChild(old_error);
        err.innerHTML = message;
        err.className = "_error-inner _form_error _no_arrow";
        var wrapper = document.createElement("div");
        wrapper.className = "_form-inner";
        wrapper.appendChild(err);
        button.parentNode.insertBefore(wrapper, button);
        document.querySelector('[id^="_form"][id$="_submit"]').disabled = false;
        if (html) {
          var div = document.createElement("div");
          div.className = "_error-html";
          div.innerHTML = html;
          err.appendChild(div);
        }
      };

      //Send to the server
      window._load_script = function (url, callback) {
        var head = document.querySelector("head"),
          script = document.createElement("script"),
          r = false;
        script.type = "text/javascript";
        script.charset = "utf-8";
        script.src = url;
        if (callback) {
          script.onload = script.onreadystatechange = function () {
            if (!r && (!this.readyState || this.readyState == "complete")) {
              r = true;
              callback();
            }
          };
        }
        head.appendChild(script);
      };

      _load_script(
        `https://bountixp.activehosted.com/proc.php?u=4&f=4&s=&c=0&m=0&act=sub&v=2&or=178a563eef8c58186c0e20c5eb032358&firstname=${formBus.fields.firstName.value}&lastname=${formBus.fields.lastName.value}&email=${formBus.fields.email.value}&phone=${formBus.fields.mobileNumber.value}&field[13]=${this.countryValue}&field[14]=${formBus.fields.companyName.value}&field[17]=${formBus.fields.employeeCount.value}&field[16]=${formBus.fields.message.value}&field[3]=${ctaRefferer}&field[4]=${cta}&field[5]=&field[6]=&field[7]=${plan}&field[8]=${term}&field[9]=${country}&field[10]=&field[11]=&jsonp=true`
      );
    },
  },
};
</script>

<style>
.bxp-form {
  width: 720px !important;
  align-content: center !important;
  justify-content: center !important;
  margin: auto;
}

.get-in-touch {
  display: flex;
  flex-direction: row;
  width: 300px !important;
}
.env-img {
  height: 26px !important;
  width: 33px !important;
  margin-top: 7px;
}

.get-in-touch-heading {
  margin-left: 10px;
  height: 40px !important;
  width: 250px !important;
  /* color: #a6ce38; */
  color: #282829;
  font-family: Roboto;
  font-size: 40px;
  letter-spacing: 0;
  line-height: 40px;
  margin-bottom: 14px;
}

.schedule-a-conversatation {
  height: 48px;
  width: 700px;
  color: #282829;
  font-family: Roboto;
  font-size: 16px !important;
  letter-spacing: 0;
  line-height: 24px;
}

.divider-line {
  height: 1px;
  width: 720px;
  background-color: #f6f6f8;
  margin-top: 27px;
}

.contact-us-gridlayout {
  display: grid;
  grid-template-columns: 300px 300px;
  column-gap: 80px;
  justify-content: center;
}

.midwords {
  color: #a6ce38;
  font-weight: bold;
}

.agree-row {
  display: flex;
  flex-direction: row;
  margin-top: 44px;
}
.v-input--selection-controls {
  margin-top: 0px !important;
  padding-top: 0px !important;
}
.checkbox {
  height: 30px;
  width: 30px;
  margin-right: 10px;
  /* align-content: center !important;
  justify-content: center !important; */
}

.agree-to-terms {
  /* height: 22px; */
  /* width: 281px; */
  color: #a7a7a9;
  font-family: Roboto;
  font-size: 12px;
  /* font-weight: bold; */
  letter-spacing: 0;
  line-height: 22px;
}

.submit-button {
  margin-left: auto;
}

.captcha-text {
  height: 20px;
  width: 445px;
  color: #282829;
  font-family: "Open Sans";
  font-size: 10px;
  letter-spacing: 0;
  line-height: 10px;
}

.divider-line-office {
  height: 1px;
  width: 720px;
  background-color: #f6f6f8;
  margin-top: 62px;
}

.office-header {
  display: flex;
  flex-direction: row;
  width: 357px !important;
  margin-top: 40px;
}

.pin-img {
  margin-top: 5px;
  height: 30px;
  width: 22px;
}

.office-header-text {
  margin-left: 10px;
  height: 40px;
  width: 305px;
  /* color: #A6CE38; */
  font-family: Roboto;
  font-size: 40px;
  letter-spacing: 0;
  line-height: 40px;
}

.office-locations {
  margin-top: 20px;
}

.loc-1-header {
  height: 20px;
  width: 496px;
  color: #282829;
  font-family: Roboto;
  font-size: 20px;
  letter-spacing: 0;
  line-height: 20px;
  font-weight: bold;
}

.loc-1-address {
  margin-top: 10px;
  height: 40px;
  width: 600px;
  font-family: Roboto;
  font-size: 12px;
  /* font-weight: normal; */
  letter-spacing: 0;
  line-height: 20px;
}

.loc-1-email {
  height: 40px;
  width: 600px;
  color: #a6ce38;
  font-family: Roboto;
  font-size: 12px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 20px;
  margin-right: 2px;
}

.loc-2-header {
  height: 20px;
  width: 496px;
  color: #282829;
  font-family: Roboto;
  font-size: 20px;
  letter-spacing: 0;
  line-height: 20px;
  margin-top: 40px;
  font-weight: bold;
}

.address-maps-link {
  height: 40px;
  width: 600px;
  color: #a6ce38;
  font-family: Roboto;
  font-size: 12px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 20px;
  margin-left: 2px;
}
</style>